import React from "react";
import { MdGridView, MdViewList } from "react-icons/md";

export const ViewModeToggle = ({ viewMode, setViewMode }) => (
  <div
    className="my-listings-view-toggle"
    role="group"
    aria-label="Listing view mode"
  >
    <button
      type="button"
      className={`my-listings-view-toggle__btn${
        viewMode === "grid" ? " my-listings-view-toggle__btn--active" : ""
      }`}
      onClick={() => setViewMode("grid")}
      aria-pressed={viewMode === "grid"}
    >
      <MdGridView size={18} aria-hidden="true" />
      <span>Grid</span>
    </button>
    <button
      type="button"
      className={`my-listings-view-toggle__btn${
        viewMode === "detailed" ? " my-listings-view-toggle__btn--active" : ""
      }`}
      onClick={() => setViewMode("detailed")}
      aria-pressed={viewMode === "detailed"}
    >
      <MdViewList size={18} aria-hidden="true" />
      <span>Detailed</span>
    </button>
  </div>
);
